import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CONFIG } from '../../environments/config';
import { gridPageProjectIdRequest, gridPageRequest, ProductInventory, ProductLedger } from '../model/common/common.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ProjectBudget } from '../model/project-budget/project-budget.module';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  constructor(private httpClientService: HttpClientService) { }

  // system configuration

  public getSystemConfig(data: any) {
    return this.httpClientService.post(CONFIG.SYSTEMCONFIGURATION.GET_SYSTEMCONFIG, data);
  }

  public updateSystemConfig(data: any) {
    return this.httpClientService.post(CONFIG.SYSTEMCONFIGURATION.UPDATE_STEMCONFIG, data);
  }

  public autoSearchSystemConfig(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.SYSTEMCONFIGURATION.AUTOSEARCHSTEMCONFIG}?searchText=${seachkey}`);
  }

  public getSearchSystemConfigById(data: any) {
    return this.httpClientService.get(`${CONFIG.SYSTEMCONFIGURATION.GET_STEMCONFIGBYID}?id=${data}`);
  }

  public getSystemConfigByAppKey(AppKey: string) {
    return this.httpClientService.get(`${CONFIG.SYSTEMCONFIGURATION.GET_STEMCONFIG_BY_APPKEY}?AppKey=${AppKey}`);
  }


  // products

  public createProduct(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATEPRODUCT, data);
  }

  public getProducts(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PRODUCT, data);
  }

  public getExportProducts(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_EXPORT_PRODUCT, data);
  }

  public getProductById(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PRODUCTBYID}?id=${data}`);
  }
  public getProductByCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PRODUCTBYCODE}?code=${data}`);
  }
  public getProductByName(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PRODUCTBYNAME}?name=${data}`);
  }

  public updateProduct(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_PRODUCT, data);
  }

  public autogenerateProductCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_PRODUCTCODE);
  }
  public autogenerateProductCodeNew() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_PRODUCTCODENEW);
  }
  public getautogenerateProductCode(prefix: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.AUTOGENERATE_PRODUCTCODE}?prefix=${prefix}`);
  }
  public getautogenerateProductCodeNext(prefix: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_NEXTPRODUCTCODE}?prefix=${prefix}`);
  }
  // public getautogenerateProductCodeNext(prefix: string) {
  //   return this.httpClientService.get(
  //     `${CONFIG.INVENTORY.GET_NEXTPRODUCTCODE}?prefix=${prefix}`,
  //     { responseType: 'text' }   
  //   );
  // }


  public createBillOfMaterial(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATEBILLOFMATERIAL, data)
  }

  public getAllBillOfMaterial(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.GETALLBILLOFMATERIAL, data)
  }

  public getBillOfMaterialById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.INVENTORY.GETBILLOFMATERIAL}?${queryParam}`);
  }
  public updateBillOfMaterial(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATEBILLOFMATERIAL, data)
  }
  public deleteBillOfMaterial(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETEBILLOFMATERIAL, data)
  }

  public autoSearchBOM(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.AUTOSEARCHBOM}?searchText=${seachkey}`);
  }

  public deleteProduct(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_PRODUCT, data);
  }

  public createBillOfMaterialLineItem(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATEBILLOFMATERIALLINEITEM, data)
  }
  public getBillOfMaterialLineItem(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GETBILLOFMATERIALLINEITEM}?id=${data}`);
  }

  public getProjectBillOfMaterialLineItem(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GETPROJECTBILLOFMATERIALLINEITEM}?id=${data}`);
  }

  public getProductType() {
    const data = { "pageIndex": 0, "pageSize": 100, "id": 0 }
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PRODUCT_TYPE, data);
  }

  public getProductByType(data: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PRODUCTTYPEYBYCODE}?productType=${data}`);
  }

  public getCatagory() {
    const data = { "pageIndex": 0, "pageSize": 100, "id": 0 }
    return this.httpClientService.post(CONFIG.INVENTORY.GET_CATEGORYLIST, data);
  }

  public checkProductCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_PRODUCTCODE}?ProductCode=${data}`);
  }

  public autogenerateProjectCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_PROJECTNUMBER);
  }

  public deleteBOMLineItem(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETEBOMLINEITEM, data);
  }

  public updateBOMLineItem(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATEBILLOFMATERIALLINEITEM, data);
  }

  public getInventoryStatus(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_INVENTORYSTATUS}?ProductCode=${data}`);
  }

  public getInventoryStatusByWarehouse(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_INVENTORYSTATUSWAREHOUSE}?warehouseId=${data}`);
  }

  public getInventoryStatusByProductWarehouse(ProductCode: string, WarehouseId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_INVENTORY_STATUS_BY_PRODUCT_WAREHOUSE}?ProductCode=${ProductCode}&warehouseId=${WarehouseId}`);
  }

  public getLedgerTransaction(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_LEDGERSTATUS, data);
  }

  public getLedgerTransactionByWarehouse(data: any, warehouseId: number) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GET_LEDGERSTATUSBY_WAREHOUSEID}?warehouseId=${warehouseId}`, data);
  }

  public updateInventory(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_INVENTORY, data);
  }
  public updateInventoryNew(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_INVENTORY_NEW, data);
  }
  public UpdateInventoryAndProductLedger(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_INVENTORYANDPROJECTLEDGER, data);
  }

  public createProject(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATEPROJECT, data);
  }

  public updateProject(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATEPROJECTBOM, data)
  }

  public getAllProjectBom(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.GETALLPROJECTBOM, data)
  }

  public getProjectBomId(id: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GETPROJECTBYID}?id=${id}`);
  }

  public getProjectTransactions(id: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GETPROJECTTRANSACTIONS}?id=${id}`);
  }

  public getProjectBomCode(code: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GETPROJECTBYCODE}?code=${code}`);
  }
  public getProjectBOMForReport(id: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GETPROJECTBYIDFORREPORT}?id=${id}`);
  }

  public deleteProjectBom(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETEPROJECTBOM, data)
  }
  public uploadImage(productid: number, formData: FormData) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.UPLOAD_IMAGE}/${productid} `, formData);
  }
  public getImage(productId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_IMAGE}/${productId} `);
  }

  //Delivery Challan

  public getDeliveryChallan(data: any, Status: string) {
    return this.httpClientService.post(`${CONFIG.DELIVERYCHALLAN.GET_DELIVERY_CHALLAN}?Status=${Status}`, data)
  }

  public getDCById(data: any) {
    return this.httpClientService.get(`${CONFIG.DELIVERYCHALLAN.GET_DELIVERY_CHALLAN_BYID}?id=${data}`);
  }

  public createDeliveryChallan(data: any) {
    return this.httpClientService.post(`${CONFIG.DELIVERYCHALLAN.CREATE_DELIVERY_CHALLAN}`, data);
  }

  public updateDeliveryChallan(data: any) {
    return this.httpClientService.post(`${CONFIG.DELIVERYCHALLAN.UPDATE_DELIVERY_CHALLAN}`, data);
  }

  public deleteDeliveryChallan(data: any) {
    return this.httpClientService.post(`${CONFIG.DELIVERYCHALLAN.DELETE_DELIVERY_CHALLAN}`, data);
  }

  public createDCLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.DELIVERYCHALLAN.CREATE_DC_LINEITEM}`, data);
  }

  public updateDCLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.DELIVERYCHALLAN.UPDATE_DC_LINEITEM}`, data);
  }

  public deleteDCLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.DELIVERYCHALLAN.DELETE_DC_LINEITEM}`, data);
  }

  public getDCLineitem(data: any) {
    return this.httpClientService.get(`${CONFIG.DELIVERYCHALLAN.GET_DC_LINEITEM_BYDCNO}?id=${data}`);
  }

  public getAutogenDCNo() {
    return this.httpClientService.get(`${CONFIG.SALES.AUTOGENERATE_DCNUMBER}`);
  }

  public searchDC(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.DELIVERYCHALLAN.SEARCH_DELIVERY_CHALLAN}/search?searchText=${seachkey}`);
  }

  public checkDCNumber(data: any) {
    return this.httpClientService.get(`${CONFIG.DELIVERYCHALLAN.CHECK_DC_NO}?DCNumber=${data}`);
  }

  public createManualInventory(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.CREATE_MANUAL_INVENTORY}`, data);
  }

  public getManualInventoryList(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GET_MANUAL_INVENTORY_LIST}`, data);
  }

  public getInventoryAdjustmentById(data: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_INVENTORY_ADJUSTMENT_BY_ID}?id=${data}`);
  }

  public searchInventoryAdjustment(data: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCH_INVENTORY_ADJUSTMENT}?id=${data}`);
  }

  public glPostInventoryAdjustment(id: number, body: { createdBy: string } = { createdBy: '' }) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GL_POST_INVENTORY_ADJUSTMENT}/${id}`, body);
  }

  public getGlPostingStatus(transactionNo: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GL_POSTING_STATUS}/${transactionNo}`);
  }

  public getGlEntriesForInventoryAdjustment(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GL_ENTRIES_INVENTORY_ADJUSTMENT}/${id}`);
  }

  public glPostVendorBill(vendorBillId: number, body: { createdBy: string }) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GL_POST_VENDOR_BILL}/${vendorBillId}`, body);
  }

  public getGlEntriesForVendorBill(vendorBillId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GL_ENTRIES_VENDOR_BILL}/${vendorBillId}`);
  }

  public glPostVendorPayment(vendorPaymentId: number, body: { createdBy: string }) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GL_POST_VENDOR_PAYMENT}/${vendorPaymentId}`, body);
  }

  public getGlEntriesForVendorPayment(vendorPaymentId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GL_ENTRIES_VENDOR_PAYMENT}/${vendorPaymentId}`);
  }

  public glPostPurchaseReturn(returnPurchaseOrderId: number, body: { createdBy: string }) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GL_POST_PURCHASE_RETURN}/${returnPurchaseOrderId}`, body);
  }

  public getGlEntriesForPurchaseReturn(returnPurchaseOrderId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GL_ENTRIES_PURCHASE_RETURN}/${returnPurchaseOrderId}`);
  }

  // project budget

  public getAllProjectBudget(data: any) {
    return this.httpClientService.post(CONFIG.PROJECTBUDGET.GETALLPROJECTBUDGET, data)
  }

  public createProjectBudget(data: ProjectBudget) {
    return this.httpClientService.post(CONFIG.PROJECTBUDGET.CREATEPROJECTBUDGET, data);
  }

  public getProjectBudgetById(data: any) {
    return this.httpClientService.get(`${CONFIG.PROJECTBUDGET.GET_PROJECTBUDGETBYID}?id=${data}`);
  }

  public updateProjectBudget(data: any) {
    return this.httpClientService.post(CONFIG.PROJECTBUDGET.UPDATE_PROJECTBUDGET, data);
  }

  public deleteProjectBudget(data: any) {
    return this.httpClientService.post(CONFIG.PROJECTBUDGET.PROJECTBUDGET, data);
  }

  public autoSearchSalesOrderNumber(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.PROJECTBUDGET.AUTOSEARCHSALESORDERNUMBER}?searchText=${seachkey}`);
  }



  // Bill of Materilas for Sparsh  03-06-2025

  public createBOM(data: any) {
    return this.httpClientService.post(CONFIG.BILLOFMATERIAL.CREATEBOM, data)
  }

  public getAllBillOfMaterials(data: any) {
    return this.httpClientService.post(CONFIG.BILLOFMATERIAL.GETALLBOM, data)
  }

  public getBomById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.BILLOFMATERIAL.GETBOM}?${queryParam}`);
  }

  public updateBOM(data: any) {
    return this.httpClientService.post(CONFIG.BILLOFMATERIAL.UPDATEBOM, data)
  }

  public deletebom(data: any) {
    return this.httpClientService.post(CONFIG.BILLOFMATERIAL.DELETEBOM, data)
  }


  public createBOMLineItem(data: any) {
    return this.httpClientService.post(CONFIG.BILLOFMATERIAL.CREATEBOMLINEITEM, data)
  }

  public getBomLineItem(data: any) {
    return this.httpClientService.get(`${CONFIG.BILLOFMATERIAL.GETBOMLINEITEM}?id=${data}`);
  }

  public updateBilOfMaterialLineItem(data: any) {
    return this.httpClientService.post(CONFIG.BILLOFMATERIAL.UPDATEBOMLINEITEM, data);
  }

  public deleteBillOfMaterialLineItem(data: any) {
    return this.httpClientService.post(CONFIG.BILLOFMATERIAL.DELETEBILLOFMATERIALLINEITEM, data);
  }

  public autoSearchBom(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.BILLOFMATERIAL.AUTOSEARCHBOM}?searchText=${seachkey}`);
  }

  public autoSearchBomline(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.BILLOFMATERIAL.AUTOSEARCHBOMLINEITEM}?searchText=${seachkey}`);
  }

  public searchBillOfMaterials(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.BILLOFMATERIAL.AUTOSEARCHBOMS}?searchText=${seachkey}`);
  }

  public getBillOfMaterialLineItemSparsh(data: any) {
    return this.httpClientService.get(`${CONFIG.BILLOFMATERIAL.GETBILLOFMATERIALLINEITEMSPARSH}?id=${data}`);
  }

  //Project Task
  public getAllCompany() {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_ALL_COMPANY}`);
  }
  public getAllProject() {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_ALL_PROJECT}`);
  }
  public getAllUser() {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_ALL_USER}`);
  }
  public getProjectTaskList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PROJECTTASKLIST, data);
  }
  public getProjectTaskById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTTASKBYID}?id=${id}`);
  }
  public createProjectTask(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATE_PROJECTTASK, data);
  }
  public updateProjectTask(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_PROJECTTASK, data);
  }

  public UpdateProjectTaskpriority(data: { ProjectTaskCode: string, Priority: string }) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.UPDATEPRIORITY}`, data);
  }
  public deleteProjectTask(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_PROJECTTASK, data);
  }
  public searchProjectTask(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHPROJECTTASK}?searchText=${seachkey}`);
  }

  public autogenerateProjectTaskCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_PROJECTTASKCODE);
  }
  public checkProjectTaskCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_PROJECTTASK_CODE}?ProjectTaskCode=${data}`);
  }

  public getProjectTaskListByReminder(startDate: any, endDate: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTTASK_LIST_BY_REMINDER}?startDate=${startDate}&endDate=${endDate}`,);
  }

  public getIsClosedCountById(projectBoMIdForEmail: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_GETISCLOSEDBYID}?projectBoMId=${projectBoMIdForEmail}`);
  }

  //Project Timesheet
  public autogenerateTimesheetCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_TIMESHEETCODE);
  }

  public createProjectTimesheet(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATE_PROJECTTIMESHEET, data);
  }

  public getProjectTimesheetList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PROJECTTIMESHEETLIST, data);
  }

  public deleteProjectTimesheet(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_PROJECTTIMESHEET, data);
  }

  public updateProjectTimesheet(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_PROJECTTIMESHEET, data);
  }

  public checkProjectTimesheetCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_PROJECTTIMESHEET_CODE}?ProjectTimesheetCode=${data}`);
  }

  public getProjectTimesheetById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTTIMESHEETBYID}?id=${id}`);
  }

  public getProjectTaskForTimesheet(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PROJECTTASKFORTIMESHEET, data);
  }

  public getTimesheetCallByAppointment(startDate: any, endDate: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_TIMESHEETCALLAPPOINTMENT}?startDate=${startDate}&endDate=${endDate}`,);
  }

  // HRMS Timesheet
  public autogenerateHRMSTimesheetCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_HRMSTIMESHEETCODE);
  }

  public getHRMSTimesheetList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_HRMSTIMESHEETLIST, data);
  }

  public getHRMSTimesheetById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_HRMSTIMESHEETBYID}?id=${id}`);
  }

  public createHRMSTimesheet(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATE_HRMSTIMESHEET, data);
  }

  public updateHRMSTimesheet(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_HRMSTTIMESHEET, data);
  }

  public checkHRMSTimesheetCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_HRMSTIMESHEET_CODE}?HRMSTimesheetCode=${data}`);
  }

  public deleteHRMSTimesheet(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_HRMSTIMESHEET, data);
  }

  public getHRMSTimesheetCallByAppointment(startDate: any, endDate: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_HRMSTIMESHEETCALLAPPOINTMENT}?startDate=${startDate}&endDate=${endDate}`,);
  }


  //Project Task Comment
  public addProjectTaskComment(comment: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.ADD_PROJECTTASK_COMMENT}`, comment);
  }
  public updateProjectTaskComment(comment: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.UPDATE_PROJECTTASK_COMMENT}`, comment);
  }
  public deleteProjectTaskComment(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_PROJECTTASK_COMMENT, data);
  }
  public getProjectTaskCommentByTaskId(tasksId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTTASK_COMMENTS_BYTaskID}?taskId=${tasksId}`);
  }
  public getProjectTaskCommentByTaskCode(taskCode: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTTASK_COMMENTS_BYTaskCode}?taskCode=${taskCode}`);
  }

  //Project phase
  public getProjectPhaseList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PROJECTPHASELIST, data);
  }
  public getProjectPhaseById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTPHASEBYID}?id=${id}`);
  }
  public createProjectPhase(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATE_PROJECTPHASE, data);
  }
  public updateProjectPhase(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_PROJECTPHASE, data);
  }
  public deleteProjectPhase(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_PROJECTPHASE, data);
  }
  public searchProjectPhase(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHPROJECTPHASE}?searchText=${seachkey}`);
  }
  public autogenerateProjectPhaseCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_PROJECTPHASECODE);
  }
  public checkProjectPhaseCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_PROJECTPHASE_CODE}?ProjectPhaseCode=${data}`);
  }

  public getProjectTaskProjectList(data: gridPageProjectIdRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PROJECTTASKPROJECTLIST, data);
  }

  public getProjectTasksByIds(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PROJECTTASKPROJECTLIST, data);
  }

  public searchProjectTaskByProject(searchKey: string, projectId: number) {
    return this.httpClientService.get(
      `${CONFIG.INVENTORY.SEARCH_PROJECTTASKPROJECTLIST}?searchText=${encodeURIComponent(searchKey)}&projectId=${projectId}`
    );
  }

  public getPhasesForCalender(startDate: any, endDate: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PHASES_CALENDER}?startDate=${startDate}&endDate=${endDate}`,);
  }

  //Project Phase ImportedTask
  public getProjectPhaseImportedTaskList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PROJECTPHASEIMPORTEDTASK_LIST, data);
  }
  public createProjectPhaseImportedTask(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.ADD_PROJECTPHASEIMPORTEDTASK, data);
  }
  public deleteProjectPhaseImportedTask(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_PROJECTPHASEIMPORTEDTASK, data);
  }
  public getProjectPhaseImportedByPhaseId(tasksId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTPHASEIMPORTEDTASK_BYTaskID}?taskId=${tasksId}`);
  }
  public getCompletionByPhase(phaseId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTPHASEIMPORTEDTASK_BYPhaseID}?phaseId=${phaseId}`);
  }

  //Project Phase Comment
  public addProjectPhaseComment(comment: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.ADD_PROJECTPHASE_COMMENT}`, comment);
  }
  public updateProjectPhaseComment(comment: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.UPDATE_PROJECTPHASE_COMMENT}`, comment);
  }
  public deleteProjectPhaseComment(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_PROJECTPHASE_COMMENT, data);
  }
  public getProjectPhaseCommentByTaskId(tasksId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTPHASE_COMMENTS_BYTaskID}?taskId=${tasksId}`);
  }
  public getProjectPhaseCommentByTaskCode(taskCode: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROJECTPHASE_COMMENTS_BYTaskCode}?taskCode=${taskCode}`);
  }


  //created by Nilesh for System Setting
  public getUnitByAppKey(AppKey: string) {
    return this.httpClientService.get(`${CONFIG.SYSTEM.GET_UNITCONFIG_BY_APPKEY}?AppKey=${AppKey}`);
  }

  public getDeptByAppKey(AppKey: string) {
    return this.httpClientService.get(`${CONFIG.SYSTEM.GET_DEPTCONFIG_BY_APPKEY}?AppKey=${AppKey}`);
  }

  //Vendor Bill
  public autogenerateVendorBillCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_VENDORBILLCODE);
  }
  public getVendorBillList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_VENDORBILLLIST, data);
  }
  public getVendorBillById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_VENDORBILLBYID}?id=${id}`);
  }
  public createVendorBill(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATE_VENDORBILL, data);
  }
  public updateVendorBill(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_VENDORBILL, data);
  }
  public deleteVendorBill(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_VENDORBILL, data);
  }
  public searchVendorBill(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHPVENDORBILL}?searchText=${seachkey}`);
  }
  public checkVendorBillCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_VENDORBILL_CODE}?VendorBillCode=${data}`);
  }
  public UpdateVendorBillStatus(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_VENDORBILLSTATUS, data);
  }
  public getPOReceiptForReturnPO(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GET_PO_RECEIPT_RETURNPO}`, data)
  }

  //Vendor Payment
  public autogenerateVendorPaymentCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_VENDORPAYMENTCODE);
  }
  public checkVendorPaymentCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_VENDORPAYMENT_CODE}?VendorPaymentCode=${data}`);
  }
  public createVendorPayment(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.CREATE_VENDORPAYMENT, data);
  }
  public updateVendorPayment(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_VENDORPAYMENT, data);
  }
  public deleteVendorPayment(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_VENDORPAYMENT, data);
  }
  public searchVendorPayment(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCH_VENDORPAYMENT}?searchText=${seachkey}`);
  }
  public getVendorPaymentList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_VENDORPAYMENTLIST, data);
  }
  public getVendorPaymentById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_VENDORPAYMENTBYID}?id=${id}`);
  }

  public getOpenVendorBillList(data: any, vendorId: String) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GET_OPENIVENDORBILL_BY_VENDORCODE}?vendorId=${vendorId}`, data);
  }

  public updateAccountPayable(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_ACCOUNTPAYABLE, data);
  }
  public updateMultipleAccountPayables(payload: any[]) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.UPDATE_MULTIPLE_ACCOUNTPAYABLES}`, payload);
  }
  public getAPLineItemByPRNo(PaymentReceiptNo: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_ACCOUNTPAYABLE_LINEITEM_BY_PRNO}?id=${PaymentReceiptNo}`);
  }
  public createVendorPaymentLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.CREATE_VENDORPAYMENT_LINEITEM}`, data);
  }

  public getVendorBillByVendorBillCode(vendorBillCode: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_VENDORBILL_BY_VENDORBILLCODE}?id=${vendorBillCode}`);
  }

  public getVendorPaymentLineItemByVendorPaymentCode(vendorBillCode: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_VENDORPYAMENTLINEITEM_BY_VENDORPAYMENTCODE}?id=${vendorBillCode}`);
  }

  public UpdateVendorPaymentStatus(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_VENDORPAYMENTSTATUS, data);
  }

  public updateMultipleVendorBillStatus(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_MULTIPLEVENDORPAYMENTSTATUS, data);
  }

  public getVendorPaymentLineItemByPayment(vendorPaymentId: number, vendorBillCode: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_VENDORPMTLINEITEM_BY_PAYMENT}` + `?vendorPaymentId=${vendorPaymentId}&vendorBillCode=${vendorBillCode}`);
  }

  getUnprocessedPaymentSum(vendorBillId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_UNPROCESSED_PAYMENT_SUM}?vendorBillId=${vendorBillId}`);
  }

  public updateMultipleVendorPaymentLineItem(payload: any[]) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.UPDATE_MULTIPLE_VENDORPMTLINEITEM}`, payload);
  }

  // Vendor Credits
  public applyVendorCredits(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.APPLY_VENDOR_CREDITS, data);
  }

  public getAppliedVendorCreditsByBill(vendorBillCode: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_APPLIED_VENDOR_CREDITS_BY_BILL}?vendorBillCode=${vendorBillCode}`);
  }

  public getAccountPayableByBillId(vendorBillId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_ACCOUNTPAYABLE_BY_BILLID}?vendorBillId=${vendorBillId}`);
  }

  // Void_Vendor Bill And Vendor Payment

  public voidVendorBill(data: { reason: string; voidedBy: string }) {
    return this.httpClientService.post(CONFIG.INVENTORY.VOID_VENDOR_BILL, data);
  }

  public voidVendorPayment(data: { entityId: number; entityCode: string; reason: string; voidedBy: string }) {
    return this.httpClientService.post(CONFIG.INVENTORY.VOID_VENDOR_PAYMENT, data);
  }

  //Proposal
  public autogenerateProposalCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_PROPOSALCODE);
  }
  public checkProposalCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_PROPOSAL_CODE}?proposalCode=${data}`);
  }
  public getProposalList(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PROPOSALLIST, data);
  }
  public getProposalById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROPOSALBYID}?id=${id}`);
  }

  public createProposal(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.CREATE_PROPOSAL}`, data);
  }
  public updateProposal(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_PROPOSAL, data);
  }
  public deleteProposal(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.DELETE_PROPOSAL, data);
  }
  public searchProposal(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCHPROPOSAL}?searchText=${seachkey}`);
  }
  public markProposalInvoiced(proposalId: number) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.MARK_PROPOSAL_INVOICED}/${proposalId}`, {});
  }
  //Proposal Line item
  public getProposalLineitemById(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROPOSAL_LINEITEM_BYID}?id=${data}`);
  }
  public createProposalLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.CREATEPROPOSAL_LINEITEM}`, data);
  }
  public updateProposalLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.UPDATE_PROPOSAL_LINEITEM}`, data);
  }
  public deleteProposalLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.DELETE_PROPOSAL_LINEITEM}`, data);
  }

  //Proposal template
  public autogenerateProposalTemplateCode() {
    return this.httpClientService.get(CONFIG.INVENTORY.AUTOGENERATE_PROPOSALTEMPLATECODE);
  }
  public checkProposalTemplateCode(data: any) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.CHECK_PROPOSALTEMPLATE_CODE}?proposalCode=${data}`);
  }
  public getProposalTemplate(data: gridPageRequest) {
    return this.httpClientService.post(CONFIG.INVENTORY.GET_PROPOSALTEMPLATE_LIST, data);
  }
  public SearchProposalTemplate(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.SEARCH_PROPOSALTEMPLATE}?searchText=${seachkey}`);
  }
  public createProposalTemplate(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.CREATE_PROPOSALTEMPLATE}`, data);
  }

  //Proposal Design Basis
  public getProposalDesignBasisById(id: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GET_PROPOSALDESGINBASISBYID}?id=${id}`);
  }
  public createProposalDesignBasis(data: any) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.CREATE_PROPOSALDESGINBASIS}`, data);
  }
  public updateProposalDesignBasis(data: any) {
    return this.httpClientService.post(CONFIG.INVENTORY.UPDATE_PROPOSALDESGINBAS, data);
  }
  // Material Request

  public createMaterialRequest(data: any) {
    return this.httpClientService.post(CONFIG.MaterialRequest.CREATE_MATERIALREQUEST, data);
  }

  public updateMaterialRequest(data: any) {
    return this.httpClientService.post(CONFIG.MaterialRequest.UPDATE_MATERIALREQUEST, data);
  }

  public deleteMaterialRequest(data: any) {
    return this.httpClientService.post(CONFIG.MaterialRequest.DELETE_MATERIALREQUEST, data);
  }


  public getMaterialRequest(data: any) {
    return this.httpClientService.post(`${CONFIG.MaterialRequest.GET_MATERIALREQUEST}`, data)
  }

  public getMaterialRequestById(id: number) {
    return this.httpClientService.get(`${CONFIG.MaterialRequest.GET_MATERIALREQUEST_BY_ID}?id=${id}`);
  }
  public searchMR(searchText: string, pageRequest: any) {
    return this.httpClientService.get(
      `${CONFIG.MaterialRequest.SEARCH_MATERIALREQUEST}?searchText=${searchText}&pageIndex=${pageRequest.pageIndex}&pageSize=${pageRequest.pageSize}`
    );
  }
  public searchMI(searchText: string, pageRequest: any) {
    return this.httpClientService.get(
      `${CONFIG.MaterialRequest.SEARCH_MATERIALISSUES}?searchText=${searchText}&pageIndex=${pageRequest.pageIndex}&pageSize=${pageRequest.pageSize}`
    );
  }
  public checkMaterialRequestNo(data: any) {
    return this.httpClientService.get(`${CONFIG.MaterialRequest.CHECK_MATERIALREQUEST_NUMBER}?MaterialRequestNo=${data}`);
  }
  public autogenerateMaterialRequestNo() {
    return this.httpClientService.get(CONFIG.MaterialRequest.AUTOGENERATE_MATERIALREQUEST_NUMBER);
  }

  createMaterialRequestLineItem(data: any) {
    return this.httpClientService.post(CONFIG.MaterialRequestLineItem.CREATE, data);
  }

  updateMaterialRequestLineItem(data: any) {
    return this.httpClientService.post(CONFIG.MaterialRequestLineItem.UPDATE, data);
  }

  deleteMaterialRequestLineItem(data: any) {
    return this.httpClientService.post(CONFIG.MaterialRequestLineItem.DELETE, data);
  }

  getMaterialRequestLineItem(data: any) {
    return this.httpClientService.post(CONFIG.MaterialRequestLineItem.GET, data);
  }

  getMaterialRequestLineItemById(id: number) {
    return this.httpClientService.get(`${CONFIG.MaterialRequestLineItem.GET_BY_ID}?id=${id}`);
  }
  public getMaterialRequestLineItemByMaterialRequestNo(mrNo: string) {
    const encodedNo = encodeURIComponent(mrNo);
    return this.httpClientService.get(`${CONFIG.MaterialRequestLineItem.GET_MATERIALREQUEST_LINEITEMS}?id=${encodedNo}`);
  }
  public getTotalIssuedForSplits(mrNo: string) {
    const encodedNo = encodeURIComponent(mrNo);
    return this.httpClientService.get(`${CONFIG.MaterialRequestLineItem.GET_MATERIALREQUEST_LINEITEMS_ISSUEDQTY}?materialRequestNo=${encodedNo}`);
  }
  public getLastSplitMR(originalMR: string) {
    const encodedNo = encodeURIComponent(originalMR);
    return this.httpClientService.get(`${CONFIG.MaterialRequestLineItem.GET_LAST_SPLIT}?originalMR=${encodedNo}`);
  }
  public getMaterialIssueLineItem(data: any) {
    return this.httpClientService.post(CONFIG.MaterialIssueLineItem.GET, data);
  }

  public getMaterialIssueLineItemById(id: number) {
    return this.httpClientService.get(`${CONFIG.MaterialIssueLineItem.GET_BY_ID}?id=${id}`);
  }

  public createMaterialIssueLineItem(data: any) {
    return this.httpClientService.post(CONFIG.MaterialIssueLineItem.CREATE, data);
  }

  public updateMaterialIssueLineItem(data: any) {
    return this.httpClientService.post(CONFIG.MaterialIssueLineItem.UPDATE, data);
  }

  public deleteMaterialIssueLineItem(data: any) {
    return this.httpClientService.post(CONFIG.MaterialIssueLineItem.DELETE, data);
  }
  public getMaterialIssues(data: any) {
    return this.httpClientService.post(CONFIG.MaterialIssues.GET_MATERIALISSUES, data);
  }

  public getMaterialIssuesById(id: number) {
    return this.httpClientService.get(`${CONFIG.MaterialIssues.GET_BY_ID}?id=${id}`);
  }

  public createMaterialIssues(data: any) {
    return this.httpClientService.post(CONFIG.MaterialIssues.CREATE, data);
  }

  public updateMaterialIssues(data: any) {
    return this.httpClientService.post(CONFIG.MaterialIssues.UPDATE, data);
  }

  public deleteMaterialIssues(data: any) {
    return this.httpClientService.post(CONFIG.MaterialIssues.DELETE, data);
  }

  public searchMaterialIssues(searchText: string, pageRequest: any) {
    return this.httpClientService.get(
      `${CONFIG.MaterialIssues.SEARCH}?searchText=${searchText}&pageIndex=${pageRequest.pageIndex}&pageSize=${pageRequest.pageSize}`
    );
  }
  public getMaterialIssuesLineItemByMaterialIssuesNo(mrNo: string) {
    const encodedNo = encodeURIComponent(mrNo);
    return this.httpClientService.get(`${CONFIG.MaterialIssueLineItem.GET_MATERIALISSUES_LINEITEMS}?id=${encodedNo}`);
  }
  updateMaterialRequestLineItemByMRNoAndLineNo(data: any) {
    return this.httpClientService.post(CONFIG.MaterialRequestLineItem.UPDATEMATERIALREQUEST, data);
  }
  public updateMaterialRequestByCode(data: any) {
    return this.httpClientService.post(CONFIG.MaterialRequest.UPDATE_MATERIALREQUESTBYCODE, data);
  }
}
